export const starRatings = [
    { value: 5.0, text: '매우 맛있어요' },
    { value: 4.0, text: '맛있어요' },
    { value: 3.0, text: '보통이에요' },
    { value: 2.0, text: '별로에요' },
    { value: 1.0, text: '실망이에요' },
  ];
